import firebase from 'firebase/app'

import { getConstantKey, dispatchRequest } from '../helpers'
import { findUsers as findUsersService } from '../services/getUsers'

import * as algolia from '../services/algolia'
import editFolioService from '../services/editFolio'
import editUserService from '../services/editUser'
import getAllWaitingUsersService from '../services/getWaitingUsers'
import declinePermissionService from '../services/declinePermission'
import validatePermissionService from '../services/validatePermission'

import { USER_TYPE, LIST_TYPE } from '../constant'


export const getUsers = (type = USER_TYPE.MODEL, query, options = {}) => async (dispatch) => {
  const {
    collection,
    ...restOptions
  } = options

  return dispatchRequest(dispatch, 'GET_LIST', algolia.getAll(algolia.user, query, {
    tagFilters: [getConstantKey(USER_TYPE, type), 'validated'].filter(x => x),
    ...restOptions,
  }), {
    sort: options.sort || '',
    collection: collection || (USER_TYPE.MODEL ? LIST_TYPE.MODEL : LIST_TYPE.PHOTOGRAPHER),
  })
}

export const getClients = (query, options = {}) => async (dispatch) => dispatchRequest(
  dispatch,
  'GET_LIST',
  algolia.getAll(algolia.clients, query, options),
  {
    sort: options.sort || '',
    collection: LIST_TYPE.CLIENT,
  }
)

export const getClient = (id) => async (dispatch) => {
  if (!id) {
    return null
  }

  return dispatchRequest(dispatch, 'GET_CLIENT', algolia.getClientById(id))
}

export const getAllUsers = (query, options = {}) => async (dispatch) => {
  return dispatchRequest(dispatch, 'GET_LIST', algolia.getAll(algolia.user, query, {
    tagFilters: ['validated'],
    ...options,
  }), {
    sort: options.sort || '',
    collection: LIST_TYPE.USER,
  })
}

export const browseWaitingProfiles = () => async (dispatch) => {
  return dispatchRequest(dispatch, 'BROWSE_WAITING_PROFILES', algolia.browseIds(algolia.user, '', {
    tagFilters: ['waiting_approval'],
  }))
}

export const findUsers = (type = USER_TYPE.MODEL, value) => async (dispatch, getState) => {
  const { collection } = getState().admin

  dispatch({
    collection,
    type: 'GET_LIST',
  })

  const users = await findUsersService(type, value)

  return dispatch({
    data: users,
    userType: type,
    count: users.length,
    type: 'GET_LIST_SUCCESS',
  })
}

export const getAllWaitingUsers = () => async (dispatch) => {
  dispatch({
    type: 'GET_LIST',
    collection: 'waiting',
  })

  const users = await getAllWaitingUsersService()

  return dispatch({
    data: users,
    count: users.length,
    type: 'GET_LIST_SUCCESS',
  })
}

export const getUser = id => async (dispatch) => {
  if (!id) {
    return null
  }

  return dispatchRequest(dispatch, 'GET_USER', algolia.getUserById(id))
}

export const editFolio = (userId, folioId, values = {}) => async (dispatch, getState) => {
  const { user } = getState().admin
  const folio = user.folios.find(f => f.objectID === folioId)

  if (!user || !folio) {
    return null
  }

  await editFolioService(userId, folioId, values)
  return dispatch({
    type: 'EDIT_FOLIO',
    folio: {
      ...folio,
      ...values,
    },
  })
}

export const editUser = (userId, values = {}) => async (dispatch, getState) => {
  if (!userId) {
    return null
  }

  await editUserService(userId, values)

  return dispatch({
    type: 'EDIT_USER',
    user: {
      ...getState().admin.user,
      ...values,
    },
  })
}

export const validatePermission = (userId, withReturn) => async (dispatch) => {
  if (withReturn) {
    dispatch({ type: 'LOADING' })
  }

  const permission = await validatePermissionService(userId, withReturn)

  if (withReturn) {
    dispatch({ type: 'UNLOAD' })
  }

  dispatch({
    userId,
    permission,
    type: 'VALIDATE_PERMISSION',
  })
}

export const declinePermission = (userId, withReturn) => async (dispatch) => {
  if (withReturn) {
    dispatch({ type: 'LOADING' })
  }

  const permission = await declinePermissionService(userId, withReturn)

  if (withReturn) {
    dispatch({ type: 'UNLOAD' })
  }

  dispatch({
    userId,
    permission,
    type: 'DECLINE_PERMISSION',
  })
}


const synchronizeProcess = async (fn, dispatch, successMessage, parameters) => {
  dispatch({ type: 'LOADING' })
  try {
    await fn(parameters)

    if (successMessage) {
      dispatch({
        type: 'SNACK_SUCCESS',
        message: successMessage,
      })
    }
  } catch (err) {
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }

  dispatch({ type: 'UNLOAD' })
}

export const removeFolio = (folio) => async (dispatch) => {
  const db = firebase.firestore()

  dispatch({ type: 'LOADING' })

  try {
    await db.collection('users').doc(folio.userId).collection('folio').doc(folio.objectID).update({ deleted: true })

    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'The picture has been successfuly removed.',
    })
  } catch (err) {
    dispatch({
      type: 'SNACK_ERROR',
      message: `Error while removing picture: "${err.message}"`,
    })
  }

  dispatch({ type: 'UNLOAD' })
}


export const synchronizePermissions = () => dispatch => synchronizeProcess(
  firebase.functions().httpsCallable('synchronizeAllPermissions'),
  dispatch,
  'All permissions have been synchronized.',
)

export const synchronizeAllUsers = (partialUpdate = false) => dispatch => synchronizeProcess(
  firebase.functions().httpsCallable('synchronizeAllUsers'),
  dispatch,
  'All users have been synchronized with Algolia',
  { partialUpdate }
)

export const synchronizeAllClients = () => dispatch => synchronizeProcess(
  firebase.functions().httpsCallable('synchronizeAllClients'),
  dispatch,
  'All clients have been synchronized with Algolia',
)

export const synchronizeAllCastings = () => dispatch => synchronizeProcess(
  firebase.functions().httpsCallable('synchronizeAllCastings'),
  dispatch,
  'All castings have been synchronized with Algolia',
)

export const triggerEmailParticipants = params => dispatch => synchronizeProcess(
  firebase.functions().httpsCallable('triggerEmailParticipants'),
  dispatch,
  'Emails has been sent successfuly',
  params,
)
